import { render, staticRenderFns } from "./ProductsReview.vue?vue&type=template&id=1b142ccf&"
import script from "./ProductsReview.vue?vue&type=script&lang=js&"
export * from "./ProductsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports